import axios from "axios";
import clocks from "../../models/relojes/clocks";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getClocks() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/relojes`, { headers }).then(({ data }) =>
      data.map((item) => {
        return clocks.fromJson(item);
      })
    );
  }
}

export default service;
